import React, {useEffect, useState} from "react";
import firebase from "firebase";
import {StorageItem} from "../list";
import {Breadcrumb, Button, Layout, Table} from "antd";
import {FileOutlined, FolderOutlined} from "@ant-design/icons";

const {Content} = Layout;

export interface CreativesListComponentProps {
    onItemClick: (item: StorageItem) => void,
}

export const CreativesListComponent: React.FC<CreativesListComponentProps> = ({onItemClick}) => {
    const [currentPath, setCurrentPath] = useState<string>('');
    const [data, setData] = useState<StorageItem[]>();
    const [isDataLoading, setDataLoading] = useState(false);

    const loadData = (path: string) => {
        firebase.storage().ref(path).listAll().then(res => {
            const result: StorageItem[] = [];
            if (res.prefixes) {
                result.push(...res.prefixes.map(e => new StorageItem(e, true)));
            }
            if (res.items) {
                result.push(...res.items.map(e => new StorageItem(e, false)));
            }
            setDataLoading(false);
            setData(result);
        });
    }

    useEffect(() => {
        setDataLoading(true)
        loadData(currentPath);
    }, [currentPath]);

    const breadCrumbs = [
        ...currentPath.split('/'),
    ];
    const handleItemClick = (item: StorageItem) => {
        if (item.isFolder) {
            setCurrentPath(`/${item.ref.fullPath}`);
        } else {
            onItemClick(item);
        }
    }

    return (
        <Layout className='creatives-page-wrapper'>
            <div className='creatives-breadcrumbs-wrapper'>
                <Breadcrumb>
                    {breadCrumbs.map((e, index) => {
                        const subIndex = currentPath.indexOf(`/${e}`);
                        const historyPath = index > 0 ? (currentPath.substring(0, subIndex) + '/' + e) : '';
                        return <Breadcrumb.Item>
                            <Button
                                type={"link"}
                                onClick={() => {
                                    setCurrentPath(index === breadCrumbs.length - 1 ? currentPath : historyPath);
                                }}>
                                {e.trim().length === 0 ? 'Root' : e}
                            </Button>
                        </Breadcrumb.Item>
                    })}
                </Breadcrumb>
            </div>
            <Content className='creatives-list-wrapper'>
                <Table<StorageItem>
                    dataSource={data}
                    loading={isDataLoading}
                    pagination={false}
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: (event: any) => {
                                // console.log('target: ' + event.target);
                                if (event.target instanceof HTMLSpanElement) {
                                    event.preventDefault();
                                    return;
                                } else {
                                    handleItemClick(record);
                                }
                            },
                        };
                    }}
                    columns={[
                        {
                            width: 48,
                            render: (item: StorageItem) => {
                                return item.isFolder ? <FolderOutlined/> : <FileOutlined/>;
                            },
                        },
                        {
                            title: 'Name',
                            render: (item: StorageItem) => {
                                return item.ref.name;
                            },
                        }
                    ]}/>
            </Content>
        </Layout>
    );
}